import { render, staticRenderFns } from "./feedbacksmw.vue?vue&type=template&id=4745d04c&scoped=true"
import script from "./feedbacksmw.vue?vue&type=script&lang=js"
export * from "./feedbacksmw.vue?vue&type=script&lang=js"
import style0 from "./feedbacksmw.vue?vue&type=style&index=0&id=4745d04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4745d04c",
  null
  
)

export default component.exports